import { useState, useCallback } from 'react';
import { CptView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Hook for managing CPT dialog state
 */
export function useCptDialog() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingCpt, setEditingCpt] = useState<CptView | null>(null);
  const [helpDialogOpen, setHelpDialogOpen] = useState(false);

  const handleAddCpt = useCallback(() => {
    setEditingCpt(null);
    setDialogOpen(true);
  }, []);

  const handleEditCpt = useCallback((cpt: CptView) => {
    setEditingCpt(cpt);
    setDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setDialogOpen(false);
    setEditingCpt(null);
  }, []);

  const handleOpenHelpDialog = useCallback(() => {
    setHelpDialogOpen(true);
  }, []);

  const handleCloseHelpDialog = useCallback(() => {
    setHelpDialogOpen(false);
  }, []);

  return {
    dialogOpen,
    editingCpt,
    helpDialogOpen,
    handleAddCpt,
    handleEditCpt,
    handleCloseDialog,
    handleOpenHelpDialog,
    handleCloseHelpDialog,
  };
}
